import React from 'react';
import ReviewRating from './ReviewRating.jsx';
import {Grid, Typography} from '@bonprix/design-system';
import Landmark from '@core/scripts/components/landmark-adapter';

export default function StarsFilter({
    filter,
    stars,
    count,
    averageRating,
    texts,
    selectedFilters,
    onFilter,
    onRemoveFilter,
}) {
    const onFilterClick = (type, value, selectedFilters, onFilter) => {
        Landmark.sendClickLandmark('adp_reviews_stars');
        if (selectedFilters[type] !== value) {
            return onFilter?.({type, value});
        }
        return onRemoveFilter?.({type, value});
    };

    return (
        <div className="stars-filter">
            <Grid>
                <Grid.Item s={4} l={12} xl={4}>
                    <div className="stars-filter__average">
                        <div className="stars-filter__row">
                            <Typography variant="bonprix-h1">
                                <div className="stars-filter__average-value">
                                    {averageRating?.substr(0, 3)?.replace('.', ',')}
                                </div>
                            </Typography>
                        </div>
                        <div className="stars-filter__rating-wrapper">
                            <div className="stars-filter__rating-row">
                                <ReviewRating rating={stars} ratingClass="stars-filter__rating-star"/>
                            </div>
                            <div className="stars-filter__rating-row">
                                <div className="stars-filter__total-reviews-count">
                                    <Typography variant="body2">{count} {texts.ada_bewertungen}</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </Grid.Item>
                <Grid.Item s={8} l={12} xl={8}>
                    {filter.values.map((filterValue, index) => {
                        const filterValueValue = filterValue.value;
                        return (
                            <div
                                key={'stars-filter-' + index}
                                className={
                                    'stars-filter__row' +
                                    (selectedFilters[filter.type] === filterValueValue ? ' is-active' : '')
                                }
                            >
                                <div className="stars-filter__column -left">
                                    <span
                                        className="stars-filter__filter"
                                        onClick={() =>
                                            onFilterClick(filter.type, filterValueValue, selectedFilters, onFilter)
                                        }
                                    >
                                        <Typography variant="body1">
                                            {`${filterValueValue} ${texts.ada12_review_stars}`}
                                        </Typography>
                                    </span>
                                </div>
                                <div className="stars-filter__column -center">
                                    <div
                                        className="stars-filter__indicator"
                                        onClick={() =>
                                            onFilterClick(filter.type, filterValueValue, selectedFilters, onFilter)
                                        }
                                    >
                                        <div className="stars-filter__indicator-background" />
                                        <div
                                            className="stars-filter__indicator-bar"
                                            style={{width: `calc((${filterValue.count}/${count})*100%)`}}
                                        />
                                    </div>
                                </div>
                                <div className="stars-filter__column -right">
                                    <span className="stars-filter__reviews-count">
                                        <Typography variant="body2">({filterValue.count})</Typography>
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </Grid.Item>
            </Grid>
        </div>
    );
}
